import { render, staticRenderFns } from "./camp.vue?vue&type=template&id=b1f55fc2&scoped=true"
import script from "./camp.vue?vue&type=script&lang=js"
export * from "./camp.vue?vue&type=script&lang=js"
import style0 from "./camp.vue?vue&type=style&index=0&id=b1f55fc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f55fc2",
  null
  
)

export default component.exports